import { Head, useForm } from "@inertiajs/react"

import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import PartnerSettingsLayout from "@/layouts/partner/settings-layout"
import PartnerLayout from "@/layouts/partner-layout"
import { partnerSettingsBillingPath } from "@/routes"

export default function BillingSettings({
  partner,
}: {
  partner: {
    uid: string
    billing_email: string | null
    proration_enabled: boolean
  }
}) {
  const { data, setData, patch, processing } = useForm({
    partner: {
      billing_email: partner.billing_email ?? "",
      proration_enabled: partner.proration_enabled,
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    patch(partnerSettingsBillingPath())
  }

  return (
    <PartnerLayout>
      <Head title="Settings — Billing" />
      <PartnerSettingsLayout>
        <form onSubmit={handleSubmit}>
          <div className="flex max-w-md flex-col gap-5">
            <h2 className="text-sm font-semibold">Billing</h2>
            <div className="flex flex-col gap-1.5">
              <Label htmlFor="billing-email">Billing email</Label>
              <Input
                id="billing-email"
                type="email"
                value={data.partner.billing_email}
                onChange={(e) =>
                  setData("partner", {
                    ...data.partner,
                    billing_email: e.target.value,
                  })
                }
              />
            </div>
            <div className="flex items-start gap-3">
              <Checkbox
                id="proration_enabled"
                checked={data.partner.proration_enabled}
                onCheckedChange={(checked) =>
                  setData("partner", {
                    ...data.partner,
                    proration_enabled: checked as boolean,
                  })
                }
                className="mt-0.5"
              />
              <div>
                <Label htmlFor="proration_enabled" className="cursor-pointer">
                  Enable proration
                </Label>
                <p className="text-muted-foreground text-sm">
                  When enabled, mid-month agent activations are prorated based
                  on remaining days in the billing period.
                </p>
              </div>
            </div>
            <div className="flex gap-2 pt-1">
              <Button size="sm" className="rounded-sm" loading={processing}>
                Save changes
              </Button>
              <Button
                type="button"
                size="sm"
                variant="outline"
                className="rounded-sm"
              >
                Cancel
              </Button>
            </div>
          </div>
        </form>
      </PartnerSettingsLayout>
    </PartnerLayout>
  )
}
